export default {
  title: 'Exception Management Center',
  subtitle: 'Manage all business exceptions in one place',
  tabs: { my: 'My Exceptions', team: 'All Team Exceptions', pending: 'Unassigned' },
  actions: {
    search: 'Search',
    reset: 'Reset',
    refresh: 'Refresh',
    manualCreate: 'Manual Create',
    detail: 'View',
    assign: 'Assign',
    start: 'Start',
    append: 'Append Result',
    resolve: 'Submit Resolution',
    verify: 'Close',
    return: 'Return',
    close: 'Close',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Create',
    searchObject: 'Search Objects',
    batchAssign: 'Batch assign',
    config: 'Exception Configuration',
    process: 'Process',
    submitResult: 'Submit Result',
    transfer: 'Transfer',
    supplement: 'Supplement',
    verifyPass: 'Approve',
    reject: 'Reject',
    cancelSelection: 'Clear Selection',
    confirmCreate: 'Confirm Registration'
  },
  summary: {
    todayCreated: 'Created today',
    pendingCount: 'Pending',
    inProgressOverdue: 'In progress overdue',
    todayClosed: 'Closed today'
  },
  filters: {
    keyword: 'Exception no., title or description',
    status: 'Status',
    objectType: 'Object type',
    category: 'Category',
    subcategory: 'Subcategory',
    level: 'Level',
    assignee: 'Assignee',
    triggeredStart: 'Triggered from',
    triggeredEnd: 'Triggered to',
    overdue: 'Overdue',
    overdueYes: 'Overdue',
    overdueNo: 'Not overdue',
    all: 'All'
  },
  objectTypes: { DISTRIBUTION_SHIPMENT: 'Distribution shipment', TRANSPORT_CONSIGNMENT: 'Transport consignment', WAYBILL: 'Waybill', FEE: 'Fee' },
  statuses: {
    PENDING_ASSIGN: 'Unassigned',
    PENDING_PROCESS: 'Pending',
    IN_PROGRESS: 'In progress',
    RESOLVED: 'Resolved',
    CLOSED: 'Closed'
  },
  levels: { S1: 'S1 Critical', S2: 'S2 Important', S3: 'S3 Normal' },
  table: {
    no: 'Exception no.',
    title: 'Title',
    object: 'Object',
    type: 'Exception Type',
    orderNo: 'Order No.',
    description: 'Description',
    level: 'Level',
    status: 'Status',
    assignee: 'Assignee',
    triggeredAt: 'Triggered at',
    sla: 'SLA',
    overdue: 'Overdue',
    operation: 'Actions'
  },
  assignee: {
    inactive: 'Inactive user',
    unresolved: 'Assignee information pending sync'
  },
  manual: {
    title: 'Register Exception Manually',
    category: 'Category',
    categoryPlaceholder: 'Select category',
    subcategory: 'Subcategory',
    subcategoryPlaceholder: 'Select subcategory',
    level: 'Level',
    levelPlaceholder: 'Select level',
    distributionShipment: 'Distribution shipment no.',
    distributionShipmentPlaceholder: 'Select distribution shipment',
    transportConsignment: 'Transport consignment',
    transportConsignmentPlaceholder: 'Select transport consignment',
    waybill: 'Waybill no.',
    waybillPlaceholder: 'Select waybill',
    feeName: 'Fee',
    feePlaceholder: 'Select fee',
    feeSourceConsignment: 'Consignment: {value}',
    feeSourceWaybill: 'Waybill: {value}',
    feeSourceDocument: 'Source document: {value}',
    feeSourceUnknown: 'No linked waybill or consignment',
    objectType: 'Related object type',
    objectTypePlaceholder: 'Select object type',
    objects: 'Order No. / Related Object',
    objectSearchPlaceholder: 'Search by order no. or object name',
    keyword: 'Order no. or object name',
    selected: '{count} selected',
    description: 'Description',
    descriptionPlaceholder: 'Describe the exception, max 500 characters',
    assignee: 'Assignee (optional)',
    assigneePlaceholder: 'Search assignee by username'
  },
  batch: {
    title: 'Batch assign',
    selected: '{count} selected',
    assignee: 'Assignee',
    assigneePlaceholder: 'Search assignee by username'
  },
  detail: {
    manualAddition: 'Manual addition',
    title: 'Exception detail',
    base: 'Basic information',
    objects: 'Related entities',
    history: 'History',
    openObject: 'Open object',
    openDistributionShipment: 'Distribution shipment detail',
    openConsignment: 'Consignment detail',
    openWaybill: 'Tracking detail',
    slaDeadline: 'SLA deadline',
    slaOverdue: 'Overdue',
    slaNormal: 'Within SLA',
    systemOperator: 'System',
    operationContent: 'Operation note',
    operationContentPlaceholder: 'Describe the process and result',
    rejectReason: 'Return reason',
    rejectReasonPlaceholder: 'Explain why this exception is returned',
    assignee: 'Assignee',
    assigneePlaceholder: 'Search assignee by username',
    fields: {
      distributionShipmentNo: 'Distribution shipment no.',
      transportConsignmentNo: 'Transport consignment no.',
      waybillNo: 'Waybill no.',
      feeName: 'Fee name',
      businessType: 'Business type',
      supplierName: 'Supplier',
      routeName: 'Route',
      triggerCondition: 'Trigger condition',
      triggeredAt: 'Triggered at',
      sourceRule: 'Source rule',
      assignee: 'Assignee'
    },
    historyActions: {
      CREATE: 'Create',
      ASSIGN: 'Assign',
      REASSIGN: 'Reassign',
      START: 'Start processing',
      APPEND_RESULT: 'Append result',
      RESOLVE: 'Submit resolution',
      VERIFY: 'Close',
      RETURN: 'Return for processing',
      CLOSE: 'Close'
    },
    snapshot: {
      consignmentNo: 'Consignment no.',
      blNo: 'Bill of lading no.',
      expressWaybillNo: 'Express waybill no.',
      mainStatus: 'Main status',
      trackingNodeExpectedTime: 'Expected tracking-node time',
      trackingNodeStatus: 'Tracking-node status',
      voyageEtd: 'Voyage ETD',
      voyageEta: 'Voyage ETA',
      businessType: 'Business type',
      expectedCompleteTime: 'Expected completion time',
      expectedShipTime: 'Expected shipment time',
      expectedArrivalTime: 'Expected arrival time',
      consignmentStatus: 'Consignment status',
      bookingStatus: 'Booking status',
      feeConfirmStatus: 'Fee confirmation status',
      feeType: 'Fee type',
      currency: 'Currency',
      amount: 'Amount including tax',
      waybillNo: 'Related waybill no.',
      dateCreated: 'Created at',
      writeOffDate: 'Write-off date',
      receiptPaymentDate: 'Receipt/payment date',
      invoiceDate: 'Invoice date',
      writeOffStatus: 'Write-off status',
      reconciliationStatus: 'Reconciliation status',
      estimatePushStatus: 'Estimate push status',
      settlementPushStatus: 'Settlement push status'
    }
  },
  basicData: {
    title: 'Basic Data',
    subtitle: 'Maintain exception category dictionaries and levels',
    categoryTab: 'Exception Categories',
    levelTab: 'Exception Levels',
    categories: 'Exception Categories',
    levels: 'Exception Levels',
    subcategoryList: '{name} - Exception Subcategories',
    levelList: 'Exception Level List',
    subcategoryCount: 'Subcategories',
    addCategory: 'Add Category',
    addSubcategory: 'Add Subcategory',
    addLevel: 'Add Level',
    editCategory: 'Edit Exception Category',
    editSubcategory: 'Edit Exception Subcategory',
    editLevel: 'Edit Exception Level',
    selectCategory: 'Select a category on the left',
    code: 'Code',
    name: 'Name',
    sort: 'Sort',
    severity: 'Severity',
    severityHelp: 'A lower number means a higher severity and controls sorting',
    slaHours: 'Default SLA (h)',
    slaHoursForm: 'Default SLA (hours)',
    color: 'Color',
    displayColor: 'Display Color',
    enabled: 'Enabled',
    disabled: 'Disabled',
    status: 'Status',
    categoryCode: 'Category Code',
    categoryName: 'Category Name',
    subcategoryCode: 'Subcategory Code',
    subcategoryName: 'Subcategory Name',
    levelCode: 'Level Code',
    levelName: 'Level Name',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    codeRequired: 'Enter a code',
    nameRequired: 'Enter a name',
    valueRequired: 'Enter a valid value',
    categoryCodeRequired: 'Enter a category code',
    categoryNameRequired: 'Enter a category name',
    subcategoryCodeRequired: 'Enter a subcategory code',
    subcategoryNameRequired: 'Enter a subcategory name',
    levelCodeRequired: 'Enter a level code',
    levelNameRequired: 'Enter a level name',
    colorRequired: 'Select a color',
    deleteTitle: 'Confirm deletion',
    deleteCategoryConfirm: 'This category cannot be restored after deletion. Continue?',
    deleteSubcategoryConfirm: 'This subcategory cannot be restored after deletion. Continue?',
    deleteLevelConfirm: 'This level cannot be restored after deletion. Continue?',
    loadFailed: 'Failed to load basic data',
    saveSuccess: 'Saved',
    saveFailed: 'Failed to save',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Failed to delete'
  },
  rule: {
    title: 'Exception Configuration',
    subtitle: 'Configure exception level determination rules',
    back: 'Back',
    create: 'Add Rule',
    createTitle: 'Add Level Determination Rule',
    editTitle: 'Edit Level Determination Rule',
    confirm: 'Confirm',
    levelRuleEmpty: 'No level determination rules. Click Add Rule to create one.',
    listTitle: 'Level Determination Rules',
    priority: 'Priority',
    priorityPlaceholder: 'Smaller numbers run first',
    copy: 'Copy',
    copyName: '{name} - Copy',
    unassigned: 'Unassigned',
    name: 'Rule Name',
    namePlaceholder: 'e.g. Escalate severe delay to S1',
    applicableType: 'Applicable Type',
    applicableCategory: 'Applicable Category',
    applicableSubcategory: 'Applicable Subcategory',
    allTypes: 'All Types',
    allCategories: 'All Categories',
    allSubcategories: 'All Subcategories',
    selectCategoryFirst: 'Select a category first',
    levelPlaceholder: 'Select level',
    resultLevel: 'Result Level',
    deductScore: 'Deduction Score',
    deductScorePlaceholder: 'Score deducted after matching',
    conditionOverview: 'Condition Overview',
    conditionMode: 'Condition Match Mode',
    conditionModes: { ALL: 'Match All (AND)', ANY: 'Match Any (OR)', NONE: 'No Conditions' },
    conditionConnectors: { ALL: 'and', ANY: 'or' },
    conditionListAll: 'Conditions (AND - trigger when all conditions match)',
    conditionListAny: 'Conditions (OR - trigger when any condition matches)',
    addCondition: 'Add Condition',
    dimension: 'Dimension',
    conditionValue: 'Value',
    conditionValueEnd: 'End Value',
    selectValue: 'Select',
    dimensions: {
      DELAY_HOURS: 'Delay Hours',
      CUSTOMER_TIER: 'Customer Tier',
      BUSINESS_TYPE: 'Business Type'
    },
    conditionOperators: { GTE: '≥', GT: '>', EQ: '=', LT: '<', LTE: '≤', BETWEEN: 'between' },
    conditionValues: {
      CUSTOMER_TIER: { VIP: 'VIP', NORMAL: 'Normal' },
      BUSINESS_TYPE: { FCL: 'FCL', LCL: 'LCL', AIR: 'AIR', RAIL: 'Rail' }
    },
    operator: 'Operator',
    owner: 'Owner',
    owners: 'Owners (multiple)',
    assigneePlaceholder: 'Search assignee by username',
    enabled: 'Enabled',
    deleteConfirm: 'Delete rule “{name}”?'
  },
  messages: {
    loadFailed: 'Failed to load exceptions',
    summaryLoadFailed: 'Failed to load summary',
    basicDataLoadFailed: 'Failed to load exception basic data',
    teamMemberLoadFailed: 'Failed to load assignee candidates',
    detailFailed: 'Failed to load detail',
    detailVersionConflict:
      'The exception was updated. Detail has been refreshed; please try again.',
    objectSearchFailed: 'Failed to search objects',
    createSuccess: 'Exception created',
    batchAssignSuccess: 'Batch assignment completed with {successCount} succeeded.',
    batchAssignPartial:
      'Batch assignment completed: {successCount} succeeded, {failedCount} failed{errorCodes}',
    batchAssignErrorCodes: ' (error codes: {errorCodes})',
    operationSuccess: 'Operation succeeded',
    assignSuccess: 'Assigned successfully',
    startSuccess: 'Processing started',
    appendSuccess: 'Processing result updated',
    resolveSuccess: 'Processing result submitted',
    verifySuccess: 'Approved and closed',
    returnSuccess: 'Rejected and returned to processing',
    closeSuccess: 'Exception closed',
    operationFailed: 'Operation failed',
    selectObject: 'Select at least one object',
    selectPrimaryObject: 'Select at least one distribution shipment, transport consignment, or waybill',
    selectException: 'Select at least one exception',
    descriptionRequired: 'Enter a description',
    assigneeRequired: 'Select an assignee',
    contentRequired: 'Enter an operation note',
    manualBasicDataLoadFailed: 'Failed to load exception categories and levels. Please try again.',
    manualBasicDataRequired: 'Select enabled category, subcategory, and level values.',
    ruleSaveSuccess: 'Rule saved',
    ruleDeleteSuccess: 'Rule deleted',
    levelRuleFormRequired: 'Complete all required level determination rule fields.'
  }
}
